var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"level-dot",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 14 14","aria-hidden":"true"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"6","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }